import Script from "next/script";
import React from "react";

export const EsyohSnippet: React.FC = () => {
  return (
    <>
      <Script id="esyoh-pixel">
        {`!function(a,b,c){
        a._ESY=c;a=b.createElement("script");
        a.async=1;a.src="https://www.esyoh.com/clients/js/esypixel.js?agency_id=321";
        b.head.appendChild(a)}(window,document,{agency_id:"321"});`}
      </Script>
    </>
  );
};
